export enum CourseOfferingRecommendationComponentType {
    Title = 'title',
    Description = 'description',
    Image = 'image',
    Recommendation = 'recommendation',
}
